<template>
  <div class="home">
    <div class="home__hero">
      <HeroBackgroundSlider />
    </div>

    <descriptionArea
      :title="'Gli esperti del colore'"
      :description="'Concessionario di riferimento Cap Arreghini, Colorificio Postumia<br> offre una vasta gamma di pitture e vernici, ma anche scale,<br /> ponteggi, rasanti, colle e sigillanti e prodotti per decorare e risanare.<br /> Il magazzino di proprietà garantisce riordini rapidi e<br /> puntuali. E i vantaggi non finiscono qui.'"
      :image="descriptionAreaImage"/>

    <swiperProducts
      :overlineTitle="'Prodotti in evidenza'"/>

    <swiperCosaUsare
      :overlineTitle="'cosa usare per …'"
      :category="'All'"
      :currentSlug="undefined"/>

    <div>
      <div class="swiper-products__title hide-for-desktop">
        <h3>Prodotti</h3>
      </div>
      <h3 class="home-category-listings__title show-for-desktop">Prodotti</h3>
      <div
        :class="{'home-category-listings--isTouch': touch}"
        class="home-category-listings"
        :style="`background-image: url(${background})`">
        <CategoriesList
          v-if="typeof chunkArray[0] !== 'undefined'"
          :list="chunkArray[0]" />
        <CategoriesList
          v-if="typeof chunkArray[1] !== 'undefined'"
          :list="chunkArray[1]"
          :rellaxSpeed="2"/>
        <CategoriesList
          v-if="typeof chunkArray[2] !== 'undefined'"
          :list="chunkArray[2]" />
      </div>
    </div>

    <partners :image="loghiAreaImage"/>
    <stores />
    <FooterArea/>

    <NewsPopUp v-if="!loading" :viewPort="getViewPort" :cookieConsent="cookieConsent"/>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { splitEvery, transpose } from 'ramda'
import pageSeo from './seo.js'
// @ is an alias to /src
import HeroBackgroundSlider from '@/components/HeroBackgroundSlider/HeroBackgroundSlider.vue'
import NewsPopUp from '@/components/NewsPopUp/NewsPopUp.vue'
import DescriptionArea from '@/components/DescriptionArea/DescriptionArea.vue'
import SwiperProducts from '@/components/SwiperProducts/SwiperProducts.vue'
import SwiperCosaUsare from '@/components/SwiperCosaUsare/SwiperCosaUsare.vue'
import CategoriesList from '@/components/CategoriesList/CategoriesList.vue'
import Partners from '@/components/Partners/Partners.vue'
import Stores from '@/components/Stores/Stores.vue'
import FooterArea from '@/components/FooterArea/FooterArea.vue'

import matchMedia from '@/mixins/matchMedia.js'
import getSinglePages from '@/mixins/getSinglePages.js'

const json1 = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "url": "https://www.colorificiopostumia.it",
  "logo": "https://www.colorificiopostumia.it/logo.png", "name": "Colorificio Postumia",
  "telephone": "+39 0422 815 435",
  "email": "info@colorificiopostumia.it",
  "vatID": "00776590267",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Oderzo",
    "addressRegion": "TV",
    "postalCode": "31046",
    "streetAddress": "Via Postumia, 4",
    "addressCountry": "IT"
  }
}

const json2 = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "url": "https://www.colorificiopostumia.it",
  "logo": "https://www.colorificiopostumia.it/logo.png", "name": "Colorificio Postumia",
  "telephone": "+39 0421 220 689",
  "email": "cpostumiasandona@libero.it",
  "vatID": "00776590267",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "San Donà di Piave",
    "addressRegion": "VE",
    "postalCode": "30027",
    "streetAddress": "Via Vizzotto, 103",
    "addressCountry": "IT"
  }
}

export default {
  name: 'home',
  mixins: [matchMedia, getSinglePages],
  components: {
    HeroBackgroundSlider,
    NewsPopUp,
    DescriptionArea,
    SwiperProducts,
    SwiperCosaUsare,
    CategoriesList,
    Partners,
    Stores,
    FooterArea
  },
  props: {
    cookieConsent: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    pageSeo: pageSeo,
    loading: true,
    descriptionAreaImage: require('@/assets/home/pennellata-poligono.jpg'),
    loghiAreaImage: require('@/assets/home/pennellata-dritta.jpg'),
    background: require('@/assets/home/pennellata-listing-home.jpg')
  }),
  head: {
    script: [
      { 
        t: 'application/ld+json',
        i: JSON.stringify(json1)
      },
      { 
        t: 'application/ld+json',
        i: JSON.stringify(json2)
      } 
    ]
  },
  computed: {
    ...mapGetters('contentful', [
      'root'
    ]),
    ...mapGetters([
      'touch',
    ]),
    getViewPort: {
      get () {
        return this.matchMedia === 'medium' || this.matchMedia === 'small'
      }
    },
    categories: {
      get () {
        if (this.loading) return undefined
        return this.root.fields.nodesList.reduce((accumulator, currentValue) => {
          if (typeof currentValue.fields.category !== 'undefined' && typeof currentValue.fields.category.fields.image !== 'undefined' && typeof currentValue.fields.category.fields.imageSet !== 'undefined'){
            accumulator.push(currentValue.fields.category)
          }
          return accumulator
        }, [])
      }
    },
    chunkArray: {
      get () {
        if (this.loading) return [[], [], []]
        if (this.matchMedia === 'medium' || this.matchMedia === 'small')
          return transpose(splitEvery(2, this.categories))
        return transpose(splitEvery(3, this.categories))
      }
    },
    textImageLink: {
      get () {
        return {
          name: 'single-page',
          params: { slug: this.$_getPageSlug('Services') }
        }
      }
    },
    textParallaxLink: {
      get () {
        return { 
          name: 'single-page',
          params: { slug: this.$_getPageSlug('Company') } 
        }
      } 
    }
  },
  beforeRouteEnter (from, to, next) {
    next(vm => {
      vm.loadData()
    })
  },
  beforeRouteUpdate (from, to, next) {
    next(vm => {
      vm.loadData()
    })
  },
  methods: {
    ...mapActions('contentful', [
      'loadRoot'
    ]),
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadRoot()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  },
  metaInfo () {
    return {
      title: this.pageSeo.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageSeo.description },
        { property: 'og:locale', content: 'it' },
        { property: 'og:title', content: this.pageSeo.title },
        { property: 'og:description', content: this.pageSeo.description },
        { property: 'og:url', content: '' }
        // { property: 'og:image', content: this.content.images.background.xlarge }
      ],
      link: [
        { rel: 'canonical', href: location.protocol + '//' + location.host + location.pathname }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import "./style.scss";
</style>
